import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=366b6903&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366b6903')) {
      api.createRecord('366b6903', component.options)
    } else {
      api.reload('366b6903', component.options)
    }
    module.hot.accept("./Error404.vue?vue&type=template&id=366b6903&", function () {
      api.rerender('366b6903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/errors/screens/Error404.vue"
export default component.exports